export default __webpack_public_path__ + "static/media/shard-identity-active.c37ae115.jpg";